import {Pipe, PipeTransform} from '@angular/core';
import {UserDto} from '../../../Models/User/user.interface';
import {ContractDto} from '../../../Models/Rrhh/Contracts/contract.interface';

@Pipe({
  name: 'usersContracts',
  standalone: false
})
export class UsersContractsPipe implements PipeTransform {

  transform(items: UserDto[], contracts: ContractDto[]): UserDto[] {

    if (!items.length) {
      return [];
    }

    if (contracts?.length) {

      const usersContractsId = contracts.map((contract) => contract.id_usuario);
      items = items.filter((item) => usersContractsId.includes(item.id));

    }

    return items;

  }

}
